var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        [
          _c("oaFromBox", {
            attrs: {
              isAddBtn: false,
              isTotal: false,
              isViewSearch: false,
              search: _vm.search,
              sortSearch: false,
            },
            on: { confirmData: _vm.confirmData },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "flex-box mt14" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c("div", { staticClass: "title" }, [
                  _vm._v("\n          平均工时(小时) "),
                  _c("span", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.work_hours || 0)),
                  ]),
                ]),
                _vm._v(" "),
                _c("echartBox", {
                  attrs: { "option-data": _vm.optionData, styles: _vm.styles },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "right" }, [
              _c("div", { staticClass: "top" }, [
                _c("div", { staticClass: "title" }, [_vm._v("异常考勤汇总")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "right-box" },
                  _vm._l(_vm.attendanceList, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "attendance" },
                      [
                        _c("img", { attrs: { src: item.img, alt: "" } }),
                        _vm._v(" "),
                        _c("div", { staticClass: "attendance-days" }, [
                          _c("div", { staticClass: "day" }, [
                            _vm._v(_vm._s(item.num || 0)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "tips" }, [
                            _vm._v(_vm._s(item.title)),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "lower" }, [
                _c("div", { staticClass: "title" }, [_vm._v("打卡异常汇总")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "right-box" },
                  _vm._l(_vm.clockInList, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "attendance" },
                      [
                        _c("img", { attrs: { src: item.img, alt: "" } }),
                        _vm._v(" "),
                        _c("div", { staticClass: "attendance-days" }, [
                          _c("div", { staticClass: "day" }, [
                            _vm._v(_vm._s(item.num || 0)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "tips" }, [
                            _vm._v(_vm._s(item.title)),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "mt14" },
        [
          _c(
            "div",
            { staticClass: "mb10 flex" },
            [
              _c("span", { staticClass: "title-k" }, [_vm._v("个人打卡统计")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "请选择打卡结果" },
                  on: { change: _vm.getDataList },
                  model: {
                    value: _vm.where.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.where, "status", $$v)
                    },
                    expression: "where.status",
                  },
                },
                _vm._l(_vm.options, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            { staticStyle: { width: "100%" }, attrs: { data: _vm.tableData } },
            [
              _c("el-table-column", {
                attrs: { label: "姓名", prop: "card.name" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "考勤班次",
                  "min-width": "150px",
                  prop: "name",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", [_vm._v(_vm._s(row.shift_data.name))]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.getShift(row.shift_data))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "日期", prop: "created_at", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n          " + _vm._s(row.created_at) + "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: "上班1" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "最早打卡",
                      "min-width": "150",
                      prop: "province",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(row.one_shift_is_after ? "次日" : "当日")
                              ),
                            ]),
                            _vm._v(
                              "\n            " +
                                _vm._s(row.one_shift_time) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "打卡结果", prop: "city", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "div",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openFn(
                                      row.one_shift_status,
                                      row.one_shift_location_status,
                                      1,
                                      row.id
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    class:
                                      row.one_shift_status > 1 ||
                                      row.one_shift_location_status > 1
                                        ? "red"
                                        : "",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.getStatus(
                                            row.one_shift_status,
                                            row.one_shift_location_status
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                    1 < row.one_shift_status < 5 &&
                                    row.one_shift_normal !== 0
                                      ? _c("span", [
                                          _vm._v(
                                            "-" +
                                              _vm._s(row.one_shift_normal) +
                                              "分钟"
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: "下班1" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "最晚打卡",
                      prop: "province",
                      width: "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  row.one_shift_is_after == 0 ? "当日" : "次日"
                                )
                              ),
                            ]),
                            _vm._v(
                              "\n            " +
                                _vm._s(row.two_shift_time) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "打卡结果", prop: "city", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "span",
                              {
                                class:
                                  row.two_shift_status > 1 ||
                                  row.two_shift_location_status > 0
                                    ? "red"
                                    : "",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getStatus(
                                        row.two_shift_status,
                                        row.two_shift_location_status
                                      )
                                    ) +
                                    "\n              "
                                ),
                                1 < row.two_shift_status < 5 &&
                                row.two_shift_normal !== 0
                                  ? _c("span", [
                                      _vm._v(
                                        "-" +
                                          _vm._s(row.two_shift_normal) +
                                          "分钟"
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: "上班2" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "最早打卡",
                      prop: "province",
                      width: "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            row.three_shift_time
                              ? _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      row.three_shift_is_after == 0
                                        ? "当日"
                                        : "次日"
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(
                              "\n            " +
                                _vm._s(row.three_shift_time || "--") +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "打卡结果", prop: "city", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            row.three_shift_status
                              ? _c(
                                  "span",
                                  {
                                    class:
                                      row.three_shift_status > 1 ||
                                      row.three_shift_location_status > 0
                                        ? "red"
                                        : "",
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.getStatus(
                                            row.three_shift_status,
                                            row.three_shift_location_status
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                    1 < row.one_shift_status < 5 &&
                                    row.three_shift_normal !== 0
                                      ? _c("span", [
                                          _vm._v(
                                            "-" +
                                              _vm._s(row.three_shift_normal) +
                                              "分钟"
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                )
                              : _c("span", [_vm._v("--")]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: "下班2" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "最晚打卡",
                      prop: "province",
                      width: "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            row.four_shift_time
                              ? _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      row.four_shift_is_after == 0
                                        ? "当日"
                                        : "次日"
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(
                              "\n            " +
                                _vm._s(row.four_shift_time || "--") +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "打卡结果", prop: "city", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            row.four_shift_status
                              ? _c(
                                  "span",
                                  {
                                    class:
                                      row.four_shift_status > 1 ||
                                      row.four_shift_location_status > 0
                                        ? "red"
                                        : "",
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.getStatus(
                                            row.four_shift_status,
                                            row.four_shift_location_status
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                    1 < row.one_shift_status < 5 &&
                                    row.four_shift_normal !== 0
                                      ? _c("span", [
                                          _vm._v(
                                            "-" +
                                              _vm._s(row.four_shift_normal) +
                                              "分钟"
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                )
                              : _c("span", [_vm._v("--")]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: "时长统计（小时）" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "应出勤",
                      prop: "required_work_hours",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "实际出勤",
                      prop: "actual_work_hours",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "加班时长",
                      prop: "overtime_work_hours",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "请假时长",
                      prop: "leave_time",
                      width: "120",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.where.page,
              "page-size": _vm.where.limit,
              "page-sizes": [10, 15, 20],
              total: _vm.totalPage,
              layout: "total, prev, pager, next, jumper",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }